import { Component } from "@angular/core";
import { Router } from '@angular/router';

import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { GlowAuthService } from '../../services/glowadminservices/glowauth.service';

@Component({
    styleUrls: ['./generate-reset-password-token.component.scss', '../public-components.scss'],
    templateUrl: './generate-reset-password-token.component.html',
})

export class GenerateResetPasswordTokenComponent {
    public formInfo : FormGroup; 
    public errorString: string = "Login Error";
    public formError: boolean = false;
    public loading: boolean;

    constructor(
        private formBuilder: FormBuilder,
        private authService: GlowAuthService,
        private router: Router,
    ) {
    
        this.formInfo = this.formBuilder.group({
            username: ['', Validators.required]
        });

    }
    
    // Attempt to login in through our User service
    submitForm() {
        this.loading = true;
        this.formError = false;   //if you are displaying an error remove it as you are retrying     

        this.authService.generatePasswordResetToken(this.formInfo.value).subscribe((generateRestPasswordToken) => {
            console.log()
            this.loading  = false;
            if(generateRestPasswordToken.valid === true){
                this.router.navigateByUrl('/reset-password?showInfoMessage=true');
            }
            else{
                this.loading  = false;            
                this.formError = true;

            }
        }, (err) => {
            this.loading  = false;                       
            console.log("Error during login: ", err)
            this.formError = true;
            this.errorString = "Invalid username";
        
        });
    }
}